
import React      from 'react';
import CSSModules from 'react-css-modules';

import classNames   from 'classnames/bind';
import stylingUtils from '../../services/stylingUtilities';

import style from './style.scss';

class Button extends React.Component {

    static get defaultProps() {

        return {
            autoWidth: false
        }
    }

    _isSecondaryButton() {

        return this.props.theme === 'secondary';
    }

    _isSuccessButton() {

        return this.props.theme === 'success';
    }

    _isDangerButton() {

        return this.props.theme === 'danger';
    }

    _getButtonClassName() {

        var cx = classNames.bind(style);

        var baseStyle = {
            'button': true,
            'button--secondary': this._isSecondaryButton(),
            'button--success': this._isSuccessButton(),
            'button--danger': this._isDangerButton(),
            'button--auto-width': this.props.autoWidth
        };

        return cx(stylingUtils.mergeClassNames(baseStyle, this.props.className));
    }

    render() {

        return (
            <button { ...this.props }
                    className={ this._getButtonClassName() }>

                { this.props.children }

            </button>
        );
    }
}

export default CSSModules(Button, style);


// WEBPACK FOOTER //
// ./components/Button/index.js